//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import axios from 'axios';
import FeaturedOn from '~/components/FeaturedOn.vue';

export default {
    components: {
        'featured-on': FeaturedOn
    },
    data: function data() {
        return {
            loading: false,
            url: null,
            paymentMethod: '',
            lastSearchText: '',
            lastSearchType: '',
            paymentPackage: {},
            paymentPackageSettings: {},
            displayCurrency: '',
            addressesCount: 0,
            currentAddress: ''
        };
    },
    created: function created() {
        var _this = this;

        global.getPaymentMethodId().then(function (value) {
            _this.paymentMethod = value;
            if (process.client && _this.$auth.isAuthenticated()) {
                _this.$router.push({ name: 'lang', params: { lang: _this.lang } });
            }

            if (process.client) {
                _this.lastSearchText = customSessionStorage.getItem('lastSearchText');
                _this.lastSearchType = customSessionStorage.getItem('lastSearchType');

                //
                // get search address info
                //
                var lastSearchResultsJson = customSessionStorage.getItem('lastSearchResults');
                if (lastSearchResultsJson) {
                    var lastSearchResults = JSON.parse(lastSearchResultsJson);
                    if (lastSearchResults.length > 0) {
                        _this.addressesCount = lastSearchResults[0].addresses.length;
                        var address = lastSearchResults[0].addresses[lastSearchResults[0].addresses.length - 1];
                        if (address) {
                            _this.currentAddress = global.getCountryByCode(address.country);
                            if (address.state) {
                                _this.currentAddress = address.state + ', ' + _this.currentAddress;
                            }
                            if (address.city) {
                                _this.currentAddress = address.city + ', ' + _this.currentAddress;
                            }
                        }
                    }
                }
            }

            if (_this.paymentMethod == 'authorize.net') {
                _this.authorizeNet();
            }
        });
    },
    mounted: function mounted() {},

    computed: {
        lang: function lang() {
            return this.$root._route.params.lang;
        }
    },
    methods: {
        authorizeNet: function authorizeNet() {
            var _this2 = this;

            axios.get(global.websiteSettings.extra_info.api_endpoint + 'api/payment/package/authorize.net').then(function (res) {
                if (res.data) {
                    _this2.paymentPackage = res.data ? res.data : {};
                    _this2.paymentPackageSettings = _this2.paymentPackage.settings ? _this2.paymentPackage.settings : {};
                    _this2.displayCurrency = _this2.$root.trans('st_public.' + _this2.paymentPackageSettings.display_currency);
                }
            });
        },
        getAllCookies: function getAllCookies() {
            if (process.client) {
                return document.cookie;
            }
            return '';
        },
        redirect: function redirect() {
            if (this.lastSearchText && this.lastSearchType) {
                this.$router.push({ name: 'lang-search-results-type-search-loading', params: { lang: this.lang, type: this.lastSearchType, search: this.lastSearchText } });
            } else {
                this.$router.push({ name: 'lang', params: { lang: this.lang } });
            }
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/purchase-preview.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/purchase-preview.vue
// module chunks = 11